"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoData = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const NoData_1 = require("./NoData");
const NoData = (props) => {
    return (0, jsx_runtime_1.jsx)(NoData_1.NoData, Object.assign({}, props));
};
exports.NoData = NoData;
